import { useState } from 'react';
import { apiURL } from '../../../consts/URLs';
import { USERS } from '../../endpointList';
import { fetchRequest, getOptions } from '../../utils';

const useUpdatePassord = (token?: string | null) => {
    const [updatePasswordResponse, setUpdatePasswordResonse] = useState<any>();
    const [updatePasswordResult, setUpdatePasswordResult] = useState<any>();

    const updatePassword = async (obj: any) => {
        const queryParams = new URLSearchParams();

        if (obj.name) {
            queryParams.append('name', obj.name);
        }
        if (obj.email) {
            queryParams.append('email', obj.email);
        }
        if (obj.password) {
            queryParams.append('password', obj.password);
        }

        const url = `${apiURL}/${USERS}/me?${queryParams.toString()}`;
        // const options = getOptions({
        //     method: 'PUT',
        //     token: token,
        // });

        // fetchRequest(url, options, setUpdatePasswordResonse, setUpdatePasswordResult);
        const header = {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/json; charset=UTF-8',
            },
        };

        const response = await fetch(url, header);

        if (response.ok) {
            const json = await response.json();
            setUpdatePasswordResonse(json);
        } else {
            console.log('error');
        }

        console.log('sett', updatePasswordResponse);
    };

    return { updatePasswordResponse, updatePasswordResult, updatePassword };
};
export default useUpdatePassord;
